import { createRouter, createWebHashHistory } from 'vue-router';
import Editor from '@/views/editor/index.vue';
import Home from '@/views/home/index.vue';
import { WatchfaceStorage } from '@/hooks/use-watchface-history';
import { ElectronApi } from '@/services/electron.api';
import { Modal } from 'ant-design-vue';
import Test from '@/views/test.vue';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      name: 'home',
      path: '/home',
      component: Home,
      meta: {
        tabs: true,
        title: '表盘编辑器'
      }
    },
    {
      name: 'editor',
      path: '/editor',
      component: Editor,
      meta: {
        tabs: true
      }
    },
    // {
    //   path: '/test',
    //   name: '404',
    //   component: () => Test,
    //   meta: {}
    // },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
});

router.beforeEach(async (to) => {
  // 限制web端不可使用
  if (to.name != '404' && !ElectronApi.fs) {
    return {
      name: '404',
      replace: true
    };
  }

  const { fullPath } = to;

  // 清空所有modal
  Modal.destroyAll();

  // 如果今日的是home页面
  if (fullPath.includes('/home')) {
    // todo
  } else if (fullPath.includes('/editor')) {
    if (to.query.path) return;
    // 增加默认的path
    await WatchfaceStorage.init();
    const path = WatchfaceStorage.data.value?.find((item) => item.active)?.path;
    if (!path) {
      return {
        name: 'home',
        replace: true
      };
    }
    if (!to.query.path) to.query.path = path;
  }
});

export default router;
